
import { useParams } from 'react-router-dom';
import { TemporadasFormState } from '../../../context/temporadas/TemporadasFormState';
import { Form } from './form';

export const TemporadasFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Temporada":"Crear Temporada";
  
  return (
    <TemporadasFormState>
        <br />
        <Form title={title} />
    </TemporadasFormState>
  );
};
